import {
  TAG_LOADING,
  TAG_ERROR,

  TAG_GET_LIST,
  TAG_GET_LIST_NO_PAGINATION,
  TAG_GET_FILTERS,
  TAG_GET_SINGLE,
  TAG_CREATE_TAG,
  TAG_GET_TYPES
} from "actions/tag/constants";

const initialState = {
  loading: false,
  errors: [],

  tagList: {
    content: [],
    total_count: 0,
  },
  tagListNoPagination: [],
  tagFilters: [],
  tagSingle: {},

  types: []
};

export default function (state = initialState, action) {
  let tagList = [],
    tagListNoPagination = [],
    tagSingle = {},
    index;
  switch (action.type) {
    case TAG_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case TAG_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case TAG_GET_LIST:
      return {
        ...state,
        errors: [],
        loading: false,
        tagList: action.payload,
      };
    case TAG_GET_FILTERS:
      return {
        ...state,
        errors: [],
        loading: false,
        tagFilters: action.payload.content,
      };
    case TAG_GET_SINGLE:
      return {
        ...state,
        errors: [],
        loading: false,
        tagSingle: action.payload,
      };
    case TAG_GET_LIST_NO_PAGINATION:
      return {
        ...state,
        errors: [],
        loading: false,
        tagListNoPagination: action.payload,
      };
    case TAG_CREATE_TAG:
      tagList = Object.assign({}, state.tagList);
      tagList.content = Object.assign([], tagList.content);
      index = tagList.content.findIndex(item => item.id === action.payload.content.id);
      if (index > -1) {
        tagList.content[index] = action.payload.content;
      } else {
        tagList.content.push(action.payload.content);
      }

      tagListNoPagination = Object.assign([], state.tagListNoPagination);
      tagListNoPagination.content = Object.assign([], tagListNoPagination.content);
      index = tagListNoPagination.content.findIndex(item => item.id === action.payload.content.id);
      if (index > -1) {
        tagListNoPagination.content[index] = action.payload.content;
      } else {
        tagListNoPagination.content.push(action.payload.content);
      }

      tagSingle = Object.assign({}, state.tagSingle);
      if (tagSingle.id === action.payload.content.id) {
        tagSingle = action.payload.content;
      }

      return {
        ...state,
        errors: [],
        loading: false,
        tagList,
        tagListNoPagination,
        tagSingle
      };
    case TAG_GET_TYPES:
      return {
        ...state,
        errors: [],
        loading: false,
        types: action.payload.content
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tagReducer.js